// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3CCPa","imageUploader":"EGiftCard_imageUploader__ZtKsY"};